import IndustrySolutionPage from '../components/IndustrySolutionPage';
import { manufacturingData } from '@/mocks/industrySolutionsData';

export default function ManufacturingSolutionPage() {
  return <IndustrySolutionPage data={manufacturingData} />;
}